import { useTranslation } from "react-i18next";
import { DEMO_PLAYERS } from "../../tour/tourDemoFixtures";
import "./LiveTrainingTourScaffold.css";

/** Fallback live-training targets when the hall is empty during a Pingflo walk. */
export function LiveTrainingTourScaffold({ player = true }) {
  const { t } = useTranslation();
  if (player) {
    const partner = DEMO_PLAYERS[1];
    return (
      <div className="lt-page lt-tour-scaffold">
        <div className="lt-pv lt-pv--waiting">
          <div className="lt-pv__wait-card">
            <div className="lt-pv__wait-top-row">
              <h2 className="lt-pv__player-name">{DEMO_PLAYERS[0].name}</h2>
              <div className="lt-pv__hr-chip" data-tour-id="live-player-hr">
                72
              </div>
            </div>

            <div className="lt-pv__table-panel" data-tour-id="live-player-table">
              <div className="lt-pv__table-hero">
                <div className="lt-pv__table-hero-block">
                  <span className="lt-pv__table-hero-label">{t("table")}</span>
                  <span className="lt-pv__table-hero-number">#2</span>
                </div>
                <div className="lt-pv__table-hero-chips">
                  <span className="lt-pv__side-chip">A</span>
                </div>
              </div>
              <div className="lt-pv__table-roster">
                <span className="lt-pv__table-roster-title">
                  {t("liveTrainingTablePlayers")}
                </span>
                <ul className="lt-pv__table-roster-list">
                  <li className="lt-pv__table-roster-item lt-pv__table-roster-item--viewer">
                    <span className="lt-pv__table-roster-name">
                      {t("liveTrainingYou")}
                    </span>
                  </li>
                  <li className="lt-pv__table-roster-item">
                    <span className="lt-pv__table-roster-name">{partner.name}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="lt-hero" data-tour-id="live-player-exercise">
              <p className="lt-tour-scaffold__kicker">
                {t("tour_live_drill_title", "This drill")}
              </p>
              <strong>01:30</strong>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="lt-page lt-tour-scaffold">
      <div className="lt-coach-dash" data-tour-id="live-coach-floor">
        <div className="lt-coach-dash__toolbar">
          <button type="button" className="lt-coach-dash__tables-btn" data-tour-id="live-coach-tables">
            {t("liveTrainingCoachTablesBtn") || "Tables"}
          </button>
        </div>
      </div>
      <div className="lt-coach-bar-wrap" data-tour-id="live-coach-start">
        <div className="lt-coach-bar" role="toolbar">
          <span className="lt-coach-bar__btn lt-coach-bar__btn--primary">{t("start")}</span>
          <span className="lt-coach-bar__btn">{t("pause")}</span>
        </div>
      </div>
    </div>
  );
}
